import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import verify from './common/verify.js'
import hint from './common/hint.js'
import util from './common/util.js'
import userRequest from './network/userRequest.js'
import myAnime from './common/myAnime.js'
import * as echarts from 'echarts'
import 'echarts/lib/chart/map';
import 'echarts/map/js/china';
import cookie from './common/cookie.js'
import { EventBus } from './common/eventBus';
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import VueI18n from 'vue-i18n';
import messages from '../src/locales'; // 引入所有语言文件
import {VueJsonp} from 'vue-jsonp';

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts;

Vue.use(ElementUI);
Vue.use(mavonEditor);
Vue.use(VueI18n);
Vue.use(VueJsonp);

Vue.prototype.$verify = verify;
Vue.prototype.$hint = hint;
Vue.prototype.$util = util;
Vue.prototype.$myAnime = myAnime;
Vue.prototype.$cookie = cookie;
Vue.prototype.$eventBus = EventBus;
Vue.prototype.$http = userRequest;

let language = cookie.get('ldz_language');

const i18n = new VueI18n({
  locale: verify.checkIfNull(language) ? 'zh' : language, // 设置默认语言
  messages, // 设置语言资源
});


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
